export const infoToCollect = [
    {
        title: "Personal Information:",
        content: "When you create an account and use the App, we collect personal information, including your name, home address, email address and phone number.",
    },
    {
        title: "Location Information:",
        content: "We collect your device's precise location when you use the App to enable delivery services and features.",
    },
    {
        title: "Usage Information:",
        content: "We collect information about how you use the App, such as the features you access, the deliveries you make or request, and your interactions with other users.",
    },
    {
        title: "Device Information:",
        content: "We collect information about your device, such as the device type, operating system, unique device identifiers, and mobile network information.",
    }
];

export const useInfo = [
    {
        title: "To Provide and Improve the App:",
        content: "We use your information to provide, maintain, and improve the App, including to enable deliveries, process payments, communicate with you about your deliveries, and personalize your experience",
    },
    {
        title: "To Share with Other Users:",
        content: "We may share your name, and location information with other users of the App in connection with deliveries. Please note that this information may be visible to other users even after a delivery is complete.",
    },
    {
        title: "To Share with Social Media Companies:",
        content: "We may share your information with social media companies for advertising and marketing purposes. This may include sharing your information with social media platforms to target you with ads for the App.",
    },
    {
        title: "To Comply with Legal Obligations:",
        content: "We may use and disclose your information to comply with applicable laws, regulations, legal processes, or government requests.",
    }
];

export const shareInfo = [
    {
        title: "With Other Users:",
        content: "As described above, we may share your name, and location information with other users of the App.",
    },
    {
        title: "With Social Media Companies:",
        content: "We may share your information with social media companies for advertising and marketing purposes.",
    },
    {
        title: "With Service Providers:",
        content: "We may share your information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, and customer support.",
    },
    {
        title: "In Connection with Business Transfers:",
        content: " If we are involved in a merger, acquisition, or sale of all or a portion of our assets, your information may be transferred as part of that transaction.",
    },
    {
        title: "With Your Consent:",
        content: "We may share your information with other parties with your consent.",
    }
];

export const choices = [
    {
        title: "Location Information:",
        content: "You can control the App's access to your device's location through your device's settings.",
    },
    {
        title: "Account Information:",
        content: "You can update your account information in the App's settings.",
    },
    {
        title: "Marketing Communications:",
        content: "You can opt out of receiving marketing communications from us by following the instructions in those communications",
    }
];

export const definitions = [
    {
        title: "A2B Deliver:",
        content: "Refers to the company providing the delivery services."
    },
    {
        title: "User:",
        content: "Refers to any individual or entity using the Services."
    },
    {
        title: "Delivery:",
        content: "Refers to the transportation of goods from one location to another."
    },
    {
        title: "Goods:",
        content: "Refers to the items being transported through the Services."
    }
];

export const userResponsibilities = [
    {
        title: "Accuracy of Information:",
        content: " Users are responsible for providing accurate and complete information when using the Services, including delivery addresses, contact information, and descriptions of goods."
    },
    {
        title: "Compliance with Laws:",
        content: "Users must comply with all applicable laws and regulations when using the Services, including those related to the transportation of prohibited or restricted items."
    },
    {
        title: "Packaging:",
        content: " Users are responsible for ensuring that goods are properly packaged and labeled for safe transportation. A2B Deliver is not liable for damage to inadequately packaged goods."
    },
    {
        title: "Payment:",
        content: "Users agree to pay all applicable fees for the Services in a timely manner."
    }
];

export const deliverResponsibilities = [
    {
        title: "Reasonable Care:",
        content: "A2B Deliver will exercise reasonable care in the handling and transportation of goods."
    },
    {
        title: "Timely Delivery:",
        content: "A2B Deliver will make reasonable efforts to deliver goods within the estimated timeframes provided. However, A2B Deliver is not liable for delays caused by unforeseen circumstances or events beyond its control."
    },
    {
        title: "Communication:",
        content: "A2B Deliver will provide users with updates on the status of their deliveries."
    }
];

export const prohibitedItem = [
    {
        title: "Illegal substances"
    },
    {
        title: "Hazardous materials"
    },
    {
        title: "Firearms and weapons"
    },
    {
        title: "Live animals"
    },
    {
        title: "Perishable goods without adequate packaging"
    }
];

export const liabilityLimitations = [
    {
        title: "Limited Liability:",
        content: "A2B Deliver's liability for lost or damaged goods is limited to the declared value of the goods or a maximum amount specified by A2B Deliver, whichever is lower."
    },
    {
        title: "Indirect Damages:",
        content: "A2B Deliver is not liable for any indirect, consequential, or special damages arising from the use of the Services."
    }
];

export const deeplinkingPackageDetails = ["Dimensions and Weight", "Sender/Receiver details", "Clear status progression"];

export const deeplinkingDetail = ["Simplifies logistics for Users location", "Ensures secure access", "Enhances productivity"]